import {AxiosInstance} from "axios";
import UserLocation from "../model/userLocation/UserLocation";
const qs = require('qs');

export default class UserLocationApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch user locations for given roles.
	 * @param {string[]} roles
	 * @returns {Promise<UserLocation[]>}
	 */
	fetchUserLocations(roles: string[]): Promise<UserLocation[]> {
		const url = `/api/web/users/positions/`;
		const params = {
			params: {roles: roles},
			paramsSerializer: function(params: string[]) {
				return qs.stringify(params, {arrayFormat: 'repeat'})
			}
		};
		return this.axiosInstance.get(url, params).then(resp => resp.data.map(UserLocation.fromJson));
	}
}
